import { FC } from 'react';
import styled from 'styled-components';

import { ButtonIw } from '@/_pages/interwill/components/ButtonIw';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { ConfirmHandoverModalProps } from '@/widgets/modals/types';

import { ModalContainerV2 } from '../containers/ModalContainerV2';

export const ConfirmHandoverModal: FC<ConfirmHandoverModalProps> = ({ onConfirm }) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'confirmHandover' });
  const { closeModal } = useModalsStore();

  return (
    <ModalContainerV2 title={t('title')} pinBottom>
      <Text>{t.rich('text')}</Text>
      <Buttons>
        <ButtonIw type="default" onClick={closeModal}>
          {t('btnCancel')}
        </ButtonIw>
        <ButtonIw onClick={onConfirm}>{t('btnConfirm')}</ButtonIw>
      </Buttons>
    </ModalContainerV2>
  );
};

const Text = styled.p`
  margin-top: 32px;
  font-size: 14px;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: end;
  gap: 16px;
  align-items: center;
  padding-top: 40px;
  font-size: 14px;
  line-height: 20px;
`;
